import {Card, CardHeader, IconButton, makeStyles} from '@material-ui/core';
import {ReactComponent as PencilIcon} from '@generic/assets/images/icon-pencil.svg';
import {formatChargerSetTitle} from '@generic/functions/formatters';
import CHARGERS from '@generic/data/chargers';
import {useIntl} from 'react-intl';

const useStyles = makeStyles((theme) => ({
  card: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.gray[200],
    },
  },
  button: {
    '&:hover': {
      backgroundColor: theme.palette.gray[200],
    },
  },
  header: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),

    '& .MuiCardHeader-action': {
      alignSelf: 'auto',
      marginRight: 0,
      marginTop: 0,
    },
  },
  vehicleImage: {
    height: 'auto',
    width: '2.5rem',
  },
}));

export default function ChargerSetInputCard({onClick, chargerSet: {chargerCount, type}}) {
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const charger = CHARGERS.find((c) => c.type === type);
  const {imageUrl} = charger;

  return (
    <Card className={classes.card} onClick={onClick}>
      <CardHeader
        avatar={<img className={classes.vehicleImage} src={imageUrl} alt="" />}
        action={
          <IconButton
            className={classes.button}
            size="small"
            onClick={onClick}
            aria-label={formatMessage({id: 'charging.inputs.vehicleSets.editButton'})}
          >
            <PencilIcon />
          </IconButton>
        }
        className={classes.header}
        title={formatChargerSetTitle({chargerCount, type})}
      />
    </Card>
  );
}
